module.exports = __webpack_public_path__ + "static/img/5.5f4366a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/eng/5.png
// module id = dOnL
// module chunks = 0